import { createContext } from "react";

export const StepContext = createContext({
    step: 0,
    setStep: () => {
        
    }
});